import { TaxAdviceOptions } from '../../../enums';
import { GenericCheckboxStep } from '../GenericCheckboxStep';

function AdviceStep() {
  return (
    <GenericCheckboxStep
      title="What would you like advice on?"
      subtitle="Select all that apply."
      checkboxOptions={TaxAdviceOptions}
      referralFieldName="tax_advice"
      stepName="advice_step"
    />
  );
}

export { AdviceStep };
